/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Activation_Page_TitleInputs */

const de_account_activation_page_title = /** @type {(inputs: Account_Activation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Aktivierungscode anmelden`)
};

/** @type {(inputs: Account_Activation_Page_TitleInputs) => LocalizedString} */
const en_account_activation_page_title = de_account_activation_page_title;

/**

* @param {Account_Activation_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_activation_page_title = /** @type {((inputs?: Account_Activation_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Activation_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_activation_page_title(inputs)
	return en_account_activation_page_title(inputs)
});